import { Button, DataSource, Layout, Table } from "@mcleod/components";

export abstract class AutogenLayoutManageCarrierCapacity extends Layout {
    buttonAvailableTractors: Button;
    buttonCarrierCapacity: Button;
    sourceAvailTractDetail: DataSource;
    tableAddedTractors: Table;
}
